import { useContext } from 'react';
import { IconMoon, IconSun } from '@components/icons';
import SwitchToggle from '@components/switch-toggle/src/switch-toggle';
import { DarkModeContext } from '@contexts/darkMode/darkMode-context';
import classNames from 'classnames';

export const DarkModeToggle = ({ className }: { className?: string }) => {
  const { isDarkMode, toggleDarkMode, isActive } = useContext(DarkModeContext);

  return (
    <div
      className={classNames(className, {
        hidden: !isActive,
      })}>
      <SwitchToggle
        active={isDarkMode}
        onToggleSwitch={(_, e) => toggleDarkMode(e)}
        loading={false}
        variant='m'
        activeColor='bg-primary'
        inactiveColor='bg-primary'
        activeIcon={<IconMoon className='w-3 h-3 text-negative' />}
        inactiveIcon={<IconSun className='w-3 h-3 text-primary' />}
      />
    </div>
  );
};

export default DarkModeToggle;
